import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-27114a9c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "index-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Banner = _resolveComponent("Banner");
  const _component_Technologies = _resolveComponent("Technologies");
  const _component_Steps = _resolveComponent("Steps");
  const _component_Comment = _resolveComponent("Comment");
  const _component_Print = _resolveComponent("Print");
  const _component_layout = _resolveComponent("layout");
  return _openBlock(), _createBlock(_component_layout, null, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_Banner, {
      onGoPage: _ctx.goPage
    }, null, 8, ["onGoPage"]), _createVNode(_component_Technologies, {
      onGoPage: _ctx.goPage
    }, null, 8, ["onGoPage"]), _createVNode(_component_Steps, {
      onGoPage: _ctx.goPage
    }, null, 8, ["onGoPage"]), _createVNode(_component_Comment, {
      onGoPage: _ctx.goPage
    }, null, 8, ["onGoPage"]), _createVNode(_component_Print, {
      onGoPage: _ctx.goPage
    }, null, 8, ["onGoPage"])])]),
    _: 1
  });
}